export class CloneAttachment {
  static readonly type = '[Contract.Attachment] Clone Attachment';
  constructor(public attachmentID: number, public copies: number = 1) {}
}

export class DeleteAttachment {
  static readonly type = '[Contract.Attachment] Delete Attachment';
  constructor(public attachmentID: number) {}
}

export class RestoreAttachment {
  static readonly type = '[Contract.Attachment] Restore Attachment';
  constructor(public attachmentID: number) {}
}

export class AddAttachment {
  static readonly type = '[Contract.Attachment] Add Attachment';
  constructor(public Attachment: any) {}
}

export class UpdateAttachment {
  static readonly type = '[Contract.Attachment] Update Attachment';
  constructor(public Attachment: any) {}
}

export class UpdateAttachmentDocumentData {
  static readonly type = '[Contract.Attachment] Update Attachment Document Data';
  constructor(public attachmentID: number, public DocumentData: any) {}
}
